import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg width="100%" height="100%" viewBox="0 0 427 427" xmlns="http://www.w3.org/2000/svg">
                  <path d="M213.332,0C95.512,0 0,95.512 0,213.332C0,331.152 95.512,426.668 213.332,426.668C331.152,426.668 426.668,331.152 426.668,213.332C426.535,95.566 331.102,0.133 213.332,-0ZM213.332,405.332C107.293,405.332 21.332,319.371 21.332,213.332C21.332,107.293 107.293,21.332 213.332,21.332C319.371,21.332 405.332,107.293 405.332,213.332C405.211,319.32 319.32,405.211 213.332,405.332Z"/>
                  <g transform="matrix(-1,0,0,1,426.668,0)">
                      <path d="M188.355,130.637C183.918,126.758 177.18,127.211 173.301,131.645C169.426,136.082 169.879,142.82 174.313,146.699L250.469,213.332L174.309,279.969C169.871,283.848 169.422,290.586 173.297,295.02C177.176,299.457 183.914,299.91 188.352,296.031L273.684,221.363C276,219.34 277.328,216.41 277.328,213.332C277.328,210.254 276,207.328 273.684,205.301L188.355,130.637Z"/>
                  </g>
                </svg>`,
      }}
    />
  );
}
